import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import BDDashboard from './BDDashboard';

const RoleBasedDashboard = () => {
  const { user } = useAuth();
  
  if (user?.role === 'BD') {
    return <BDDashboard />;
  }
  
  return <Dashboard />;
};

export default RoleBasedDashboard;